import React from "react";

const RefreshIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <g id="surface1" transform="translate(-47.367 -47.367)">
        <path d="M56.367,47.367a9,9,0,1,0,9,9,.75.75,0,1,0-1.5,0,7.517,7.517,0,1,1-2.59-5.66l-1.91,1.91h4.5v-4.5l-1.529,1.529A8.969,8.969,0,0,0,56.367,47.367Z" />
      </g>
    </svg>
  );
};

export default RefreshIcon;
